module.exports = __webpack_public_path__ + "img/cedar.be5030ca.webp";